// extracted by mini-css-extract-plugin
export default {"user_innerWrapper":"createUser_user_innerWrapper__hfH7N","user_heading":"createUser_user_heading__7Bpci","user_input":"createUser_user_input__hfMOq"};